/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServerInformation
 */
export interface ServerInformation {
    /**
     * 
     * @type {string}
     * @memberof ServerInformation
     */
    readonly version?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerInformation
     */
    readonly buildNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ServerInformation
     */
    readonly buildTime?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerInformation
     */
    readonly gitCommit?: string;
    /**
     * 
     * @type {string}
     * @memberof ServerInformation
     */
    readonly gitBranch?: string;
}

/**
 * Check if a given object implements the ServerInformation interface.
 */
export function instanceOfServerInformation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServerInformationFromJSON(json: any): ServerInformation {
    return ServerInformationFromJSONTyped(json, false);
}

export function ServerInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
        'buildNumber': !exists(json, 'buildNumber') ? undefined : json['buildNumber'],
        'buildTime': !exists(json, 'buildTime') ? undefined : json['buildTime'],
        'gitCommit': !exists(json, 'gitCommit') ? undefined : json['gitCommit'],
        'gitBranch': !exists(json, 'gitBranch') ? undefined : json['gitBranch'],
    };
}

export function ServerInformationToJSON(value?: ServerInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

